import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-polygon",
  "use": "icon-polygon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-polygon\"><path d=\"M112 529.28V912h800V433.152h-159.168V112h-448v417.28H112z\" fill=\"#FFFFFF\" p-id=\"19994\" /><path d=\"M96 513.28h192.8V96h480v321.152H928V928H96V513.28z m32 32V896h768V449.152h-159.168V128h-416v417.28H128z\" fill=\"#5D6D7E\" p-id=\"19995\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol